import { render, staticRenderFns } from "./csa-edit.vue?vue&type=template&id=5dc468d4&scoped=true"
import script from "./csa-edit.vue?vue&type=script&lang=ts"
export * from "./csa-edit.vue?vue&type=script&lang=ts"
import style0 from "./csa-edit.vue?vue&type=style&index=0&id=5dc468d4&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc468d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5dc468d4')) {
      api.createRecord('5dc468d4', component.options)
    } else {
      api.reload('5dc468d4', component.options)
    }
    module.hot.accept("./csa-edit.vue?vue&type=template&id=5dc468d4&scoped=true", function () {
      api.rerender('5dc468d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/csa/csa-edit.vue"
export default component.exports